import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  setConfiguration: `${NAMESPACE}_CONFIGURATION_SET`,
  updateMenuPanelBuilder: `${NAMESPACE}_CONFIGURATION_UPDATE_MENU_PANELBUILDER`,

  updateMdlpStatus: `${NAMESPACE}_CONFIGURATION_ENABLE_MDLP_STATUS`,
};

export const actionCreators = {
  setConfiguration: (payload) => ({ type: actions.setConfiguration, payload }),
  updateMenuPanelBuilder: (payload) => ({ type: actions.updateMenuPanelBuilder, payload }),
  updateMdlpStatus: (payload) => ({ type: actions.updateMdlpStatus, payload }),
};

export default {
  actions,
  actionCreators
};
